"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionVoiceInternalDial = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionVoiceInternalDial = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.VoiceInternalDial,
    channels: [enums_1.ChannelEnum.Voice,],
    direction: enums_1.JourneyNodeDirectionEnum.Output,
    settings_schema: (0, base_1.settingsValidationSchema)({
        user_id: {
            type: 'number',
            required: true,
        },
        queue_id: {
            type: 'number',
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_INITIATED_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_INITIATED_OUTPUT,
                title: 'INITIATED',
            }), [constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_DONE_ANSWERED_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_DONE_ANSWERED_OUTPUT,
                required: true,
                index: 1,
                title: 'DONE',
                description: 'DONE_ANSWERED',
                color: '#5bbf1c',
            }), [constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_DONE_NO_ANSWER_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_VOICE_INTERNAL_DIAL_DONE_NO_ANSWER_OUTPUT,
                required: true,
                index: 2,
                title: 'DONE',
                description: 'DONE_NO_ANSWER',
                color: '#d91010',
            }) });
    },
});
